/* GAH-GIFTPASS-01: the moment a gift buyer in arm B answers "gift".

   Paul (Oct 3): "if they select gift, it says, 'Congrats! We included 7 days
   free prepaid coaching'", then "it says that they unlocked the 7 day gifting
   pass". layout/theme.liquid owns the state
   (GD_FLAGS.syncGiftPass writes html.gd-gift-pass and fires gd:gift-pass when
   it changes); this file does the two things that follow a TAP, never a page
   load:

   1. The toast - an ink capsule from the top edge for four seconds. The
      bundle card's own note (snippets/benchmark-gift-pass-note) says the same
      thing in place; the toast is for the visitor who answered far from it.
   2. The swap - when the cart already holds the Launch Bundle with the
      coaching subscription, its coaching line becomes the Gift Pass, so the
      cart agrees with what the page now says. The pass is added BEFORE the
      subscription line is removed: a failure between the two writes leaves
      the cart as it was plus a $0 line, never a bundle without its coaching.
      One direction only - a visitor who later says "not a gift" keeps the
      prepaid pass; a renewing subscription is never added without the Add to
      Cart that disclosed it.

   Cart writes wait for the gift switch's own attribute write
   (GDGiftToggle.idle) and hold a Check out tap (InstantCart.hold). */
(() => {
  'use strict';

  if (window.GDGiftPass) return;

  // the drawer everywhere; on /cart also the page's own item and footer sections
  const cartPage = () => {
    const page = document.querySelector('cart-items');
    return page && !page.closest('cart-drawer') && document.getElementById('main-cart-items') ? page : null;
  };
  const sectionsFor = () => {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    if (cartPage()) {
      ['main-cart-items', 'main-cart-footer'].forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.dataset.id) ids.push(el.dataset.id);
      });
    }
    return ids.join(',');
  };
  const GIFT_ICON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2.5" y="6" width="11" height="7.5" rx="1"/><path d="M1.75 4h12.5v2H1.75zM8 4v9.5M8 4c-.6-1.9-3.4-2.6-3.4-.9C4.6 4 8 4 8 4zm0 0c.6-1.9 3.4-2.6 3.4-.9C11.4 4 8 4 8 4z"/></svg>';

  let toastEl = null;
  let toastTimer = 0;
  const toast = () => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gp-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    // written after the live region exists, so screen readers announce it
    toastEl.innerHTML = `<span class="gp-toast__icon">${GIFT_ICON}</span><span><b>Congrats!</b> You unlocked the 7-Day Gift Pass. It's included in the bundle.</span>`;
    toastEl.getBoundingClientRect();
    toastEl.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toastEl.classList.remove('is-on'), 4000);
  };

  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((res) => {
    if (!res.ok) throw new Error(`${url} ${res.status}`);
    return res.json();
  });

  // the bundle-cart paint, without opening a closed drawer
  const paint = (state) => {
    window._cartState = state;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state, 'default');
    if (window.CartOptimist && typeof window.CartOptimist.reconcile === 'function') window.CartOptimist.reconcile(state);
    if (typeof updateCartAndProductJSON === 'function') updateCartAndProductJSON();
    // /cart lists every line: redraw its rows from the sections this write asked for
    const page = cartPage();
    if (page && typeof page.smoothSectionRender === 'function') page.smoothSectionRender(state);
  };

  let queue = Promise.resolve();
  const swap = () => {
    const gsub = window.GD_SUB || {};
    const gp = window.GD_GIFTPASS || {};
    if (!(gp.armed === true && gp.passId > 0 && gsub.coachId)) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        const line = (cart.items || []).find((item) =>
          item.variant_id === Number(gsub.coachId) &&
          item.selling_plan_allocation &&
          item.properties && item.properties._bm_bundle && item.properties._bm_bundle_role === 'item');
        if (!line) return false;
        return post('/cart/add.js', { items: [{ id: gp.passId, quantity: line.quantity, properties: line.properties }] })
          .then(() => post('/cart/change.js', { id: line.key, quantity: 0, sections: sectionsFor(), sections_url: window.location.pathname }))
          .then((state) => {
            paint(state);
            if (window.GD_FLAGS && window.GD_FLAGS.track) {
              window.GD_FLAGS.track('gah_giftpass_swapped', { gah_giftpass_arm: 'b_prepaid' });
            }
            return true;
          });
      });
  };
  const runSwap = () => {
    const idle = window.GDGiftToggle && typeof window.GDGiftToggle.idle === 'function' ? window.GDGiftToggle.idle() : null;
    const job = queue.then(() => idle).then(swap, swap);
    queue = job.catch(() => {});
    if (window.InstantCart && typeof window.InstantCart.hold === 'function') window.InstantCart.hold(queue, { followUp: true });
    return job;
  };

  document.addEventListener('gd:gift-pass', (event) => {
    const detail = event.detail || {};
    if (!detail.on || !detail.user) return;
    toast();
    runSwap().catch(() => {});
  });

  window.GDGiftPass = { toast, swap: runSwap };
})();
